import type { StepMap } from "@/components/onboarding/components/welcome-wizard";
import { CalendarConnectStep } from "./calendar-connect-step";
import { CalendarSelectStep } from "./calendar-select-step";

export const CalendarSetupStepsMap: StepMap = {
  "calendar-connect": {
    id: "calendar-connect",
    render: props => <CalendarConnectStep {...props} />,
  },
  "calendar-select": {
    id: "calendar-select",
    render: props => <CalendarSelectStep {...props} />,
  },
} as const;
